<template>
  <ion-page>
    <ion-content class="white">
      <ion-header style="font-weight: bold" class="ion-margin-bottom ion-margin-top ion-text-center">パスワードを忘れた方へ</ion-header>
      <div class="ion-padding">
      <div class="ion-padding-horizontal">
        <ion-label>ご登録済みのメールアドレスを入力して「メールを送信する」ボタンを押してください。</ion-label>
        <br/>
        <ion-label>入力いただいたメールアドレスに、認証コード通知メールを送信します。</ion-label>
        <br/>
        <ion-label style="display: flex; align-items: center; font-size: 18px" color="danger" class="ion-margin-top">
          <ion-icon :icon="warning" style="font-size: 22px"></ion-icon>ご注意ください
        </ion-label>
        <ion-label color="danger">
          パスワード再設定メールの送信元が変わりました。<br/>
          「info.kutsu.com」と「chiyodagrp.co.jp」からのメールが受信できるよう、受信設定してください。
        </ion-label>
        <br/>
        <br/>
        <required-input label="ご登録済のメールアドレス" class="ion-margin-top"></required-input>
        <ion-input
          id="email"
          v-model="email"
          type="email"
          name="email"
          placeholder="ご登録済のメールアドレスを入力"
          label-placement="stacked"
          helper-text="例）yamada@example.co.jp ※半角英字で入力"
          fill="outline"
          mode="md"
          color="dark"
          :class="{ 'border-danger': (errors && errors.email)}"
        ></ion-input>
        <ion-text color="danger" v-if="errors && errors.email">{{ errors.email }}</ion-text>
        <ion-button class="ion-margin-top primary-button" expand="block" @click="registerSubmit">メールを送信する ></ion-button>
        <ion-button class="ion-margin-top secondary-button" expand="block" fill="outline" @click="goToLoginPage()">ログイン画面に戻る ></ion-button>
      </div>
    </div>
    </ion-content>
    <AccountLockModal v-show="isShowAccountLockModal" @close-account-lock-modal="closeAccountLockModal" />
    <ion-loading trigger="open-loading" :duration="3000" message="処理中..."></ion-loading>
  </ion-page>
</template>

<script setup lang="ts">
import { useForm, useFormErrors, useField } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import {
  IonPage,
  IonHeader,
  IonContent,
  IonLoading,
  loadingController,
  LoadingOptions,
  IonLabel,
  IonText,
  IonInput,
  IonButton, IonIcon,
} from "@ionic/vue";

import AccountLockModal from '../../components/AccountLockModal.vue';
import RequiredInput from "@/components/RequiredInput.vue";
import request from '../../utils/Request';
import { Device } from '@capacitor/device';
import { useRouter } from 'vue-router';
import StorageService from '../../utils/StorageService';
import { ERR_ACCOUNT_IS_LOCKED } from '@/consts/error-message';
import {goToLoginPage} from "@/helpers/platform";
import {warning} from "ionicons/icons";

const router = useRouter()

const emits = defineEmits(['form-submit'])

const schema = yup.object({
  email: yup.string()
    .required('メールアドレスをご入力ください')
    .email('メールアドレスが正しくありません'),
})

const formRegisterMail = useForm({
  validationSchema: schema
})

const { value: email } = useField<string>("email")

const errors = useFormErrors() as any;

const isShowAccountLockModal = ref<boolean>(false)

async function registerSubmit() {
  const resp = await formRegisterMail.validate();
  console.log(resp)

  if (resp.valid) {
    submitForm({email: formRegisterMail.values.email, formRegisterMail: formRegisterMail})
  }
}

async function submitForm (form: any) {
  const deviceInfo = await Device.getInfo()
  const data = {
    email: form.email,
    app_id: import.meta.env.VITE_APP_ID,
    device_uuid: await StorageService.get('deviceUuid'),
    osVersion: deviceInfo.osVersion,
    os: deviceInfo.operatingSystem
  }

  const loading = await createLoading('送信処理中...')
  await loading.present()
    request.post('/forgot-password', data).then((res) => {
      if (res.status) {
        router.push({
          name: 'CompletedSendMail',
          query: {
            email: form.email,
            type: 'forgot'
          }
        })
      }
    }).catch((err) => {
      if (err.response?.status == 422) {
        console.log(err.response.data.message)
        if (err.response.data.message === ERR_ACCOUNT_IS_LOCKED) {
          isShowAccountLockModal.value = true;
        } else {
          form.formRegisterMail.setErrors(err.response.data.errors);
        }
      }
    }).finally(() => {
      loading.dismiss()
    })
}

function closeAccountLockModal() {
    isShowAccountLockModal.value = false
}

async function createLoading(msg: string, duration?: number, spinner: LoadingOptions["spinner"] = "crescent") {
  return await loadingController.create({
      message: msg,
      duration: duration,
      spinner: spinner,
    })
}
</script>

<style scoped lang="scss">
#title {
  padding-left: 5px;
  border-left: solid 7px;
  border-color: gray;
  text-align: left;
}

.description {
  font-size: 0.75rem;
}

#domain-item {
  height: 32px;
  --min-height: 32px;
  --padding-start: 0;
  --inner-padding-end: 0;
}

#domain-paragraph {
  margin: 0 10px 0 1px;
  height: 30px;
  flex: 1;
  border: solid 1px;
  border-radius: 7px 0 0 7px;
  border-color: #808080;
  padding-left: 10px;
  font-size: 12px;
  line-height: 30px;
}

#domain-copy-button {
  height: 30px;
  margin: 0 0 0 0;
  --padding-start:2em;
  --padding-end:2em;

  color: black;
  font-size: 10px;
  --background: #e6e6e6;
}


#mail-address-containers {
  --inner-padding-top: 0px;
  --padding-start: 10px;
  --inner-padding-end: 0px;
  --min-height: 37px;
  margin-top:2rem;

  ion-input {
    padding:1.5rem;

  }
}

#send-mail-button {
  width: 100%;
  margin-top: 1rem;

}

.caution {
  margin: 10px auto;
  .caution-title {
    font-size: 1rem;
    font-weight: bold;
    margin: 0.25rem auto;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .caution-icon {
    color: #b7282d;
    margin: 0.25rem;
    font-size: 1.25rem;
  }
  .caution-label {
    color: #b7282d;
  }
}


#annotation {
  font-size: 0.75rem;
}

.border-danger {
    --border-color: red;
    --border-width: 1px;
    border-radius: 5px;
}
</style>